/**
 * 시스템 메시지 상수 및 DB 저장 유틸
 *
 * 정책 테이블 기반:
 * - START_STT / END_STT: 대화기록 영역 노출, 사용자/다른 사용자에게, DB 적재
 * - SUB_MODE_OFF: 자막 히스토리 영역, 사용자한테만, DB 적재
 * - TRANS_MODE_ON / TRANS_MODE_OFF: 자막 히스토리 영역, 사용자한테만, DB 적재
 * - ENTER_ROOM / OUT_ROOM: 노출 없음, DB 적재
 * - cancel: 노출 없음, DB 적재
 * - chat: 채팅 영역, 사용자/다른 사용자에게, type='text', DB 적재
 * - voice: 대화기록+자막 히스토리, 사용자/다른 사용자, type='voice', DB 적재
 */
import { store } from '@/store';
import apiManager from '@/api';

// ─── 시스템 메시지 상수 ────────────────────────────────────────────────────

export const SYSTEM_MSG = {
  START_STT: 'START_STT',
  END_STT: 'END_STT',
  SUB_MODE_OFF: 'SUB_MODE_OFF',
  TRANS_MODE_ON: 'TRANS_MODE_ON',
  TRANS_MODE_OFF: 'TRANS_MODE_OFF',
  ENTER_ROOM: 'ENTER_ROOM',
  OUT_ROOM: 'OUT_ROOM',
} as const;

export type SystemMsgType = (typeof SYSTEM_MSG)[keyof typeof SYSTEM_MSG];

// ─── DB 저장 유틸 ──────────────────────────────────────────────────────────

export interface SaveMessageOptions {
  /** 다른 사용자의 정보로 저장할 때 (ex: OUT_ROOM은 퇴장한 사용자 정보) */
  userName?: string;
  userNo?: string;
  jitsiId?: string;
  portalId?: string;
  employeeNo?: string;
  profileUrl?: string;
  nickname?: string;
}

/**
 * 채팅/시스템/음성 메시지를 DB에 저장한다.
 * - type: 'text' | 'voice' | 'system' | 'cancel'
 * - option: 다른 사용자의 정보를 전달할 때 사용
 */
export async function saveMessageToDB(
  message: string,
  type: 'text' | 'voice' | 'system' | 'cancel',
  option?: SaveMessageOptions,
): Promise<void> {
  const cur = store.getState().local;

  const data: Record<string, unknown> = {
    roomId: cur.roomId,
    userNo: option?.userNo ?? cur.userNo ?? cur.userId,
    jitsiId: option?.jitsiId ?? cur.jitsiId,
    userName: option?.userName ?? cur.userName,
    portalId: option?.portalId ?? cur.wehagoId ?? cur.userId,
    employeeNo: option?.employeeNo ?? cur.companyNo ?? '',
    profileUrl: option?.profileUrl ?? cur.profileUrl,
    message,
    nickname: option?.nickname ?? cur.nickname,
    type,
  };

  try {
    if (cur.isGuest) {
      await apiManager.saveChattingMessage2(data);
    } else {
      await apiManager.saveChattingMessage(data);
    }
  } catch (err) {
    console.warn('[saveMessageToDB] 저장 실패:', type, err);
  }
}
